<template>
  <div class="wrapper">
    <router-view></router-view>

    <Loader :is-visible="loading" />

    <div class="animated fadeIn">
      <template v-if="['orders-list'].indexOf($route.name) > -1">
        <OrdersFilters @change="applyFilters" />
      </template>

      <div
        class="card"
        v-if="['orders-list'].indexOf($route.name) > -1 && orders && totals"
      >
        <div class="card-header">
          <i class="fa fa-align-justify"></i> Liste des commandes ({{
            ordersTotal
          }})
          <span class="total inline-block float-right">
            Total ({{ formatPrice(totals.total) || "0.00€" }})
          </span>
          <span class="total inline-block float-right">
            Avoirs ({{ formatPrice(totals.refunded) || "0.00€" }})
          </span>
          <span class="total inline-block float-right">
            Impayé traité ({{ formatPrice(totals.unpaid) || "0.00€" }})
          </span>
          <span class="total inline-block float-right">
            En attente ({{ formatPrice(totals.pending) || "0.00€" }})
          </span>
          <span class="total inline-block float-right">
            Partiel ({{ formatPrice(totals.partial) || "0.00€" }})
          </span>
          <span class="total inline-block float-right">
            Payé ({{ formatPrice(totals.payed) || "0.00€" }})
          </span>
          <div class="inline-block float-right">
            <span
              class="fa fa-info-circle"
              v-tooltip="{
                content:
                  'Totaux des commandes pour la période et le commercial donnés',
                placement: 'top',
              }"
            ></span>
          </div>
        </div>

        <div class="card-block">
          <div class="w-100 mw-100 overflow-auto">
            <Orders
              :orders="orders"
              :showInvoiceFile="true"
              @click="goToOrder"
              @showCommercialNotes="displayOrderCommercialNotes"
              @showNotes="displayOrderNotes"
              @notebookNoteAdded="notebookNoteAdded"
              @notebookNoteUpdated="notebookNoteUpdated"
              @notebookNoteDeleted="notebookNoteDeleted"
            />
          </div>

          <paginate
            v-if="pageCount"
            style="margin-top: 20px"
            v-model="page"
            :key="reRenderPagination"
            :page-count="pageCount"
            :click-handler="changePage"
            prev-text="Précédent"
            next-text="Suivant"
            container-class="pagination"
          ></paginate>
        </div>
      </div>

      <div v-else class="alert alert-info text-center">
        Sélectionnez les filtres désirés et cliquez sur "Visualiser" pour
        charger les données
      </div>
    </div>

    <modal
      v-if="modalUpdateOrderCommercialNotes.order"
      title="Notes Commercial"
      v-model="modalUpdateOrderCommercialNotes.display"
      cancelText="Annuler"
      okText="Enregistrer"
      @ok="updateOrderCommercialNotes()"
      effect="fade/zoom"
    >
      <textarea
        v-model="modalUpdateOrderCommercialNotes.order.commercialNotes"
        cols="30"
        rows="10"
        class="form-control form-normalization"
      >
      </textarea>
    </modal>

    <modal
      v-if="modalUpdateOrderManagerNotes.order"
      title="Label commande"
      v-model="modalUpdateOrderManagerNotes.display"
      cancelText="Annuler"
      okText="Enregistrer"
      @ok="updateOrderNotes()"
      effect="fade/zoom"
    >
      <i> Visible par le coach</i>
      <textarea
        v-model="modalUpdateOrderManagerNotes.order.label"
        cols="30"
        rows="10"
        class="form-control form-normalization"
      >
      </textarea>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import Paginate from "vuejs-paginate";
import Modal from "vue-strap/src/Modal";

import Loader from "@/components/utils/Loader";
import Orders from "@/components/order/Orders";
import OrdersFilters from "@/components/order/OrdersFilters";

export default {
  components: {
    Loader,
    Modal,
    Orders,
    OrdersFilters,
    Paginate,
  },

  data() {
    return {
      loading: false,
      orders: null,
      ordersTotal: 0,
      offset: 0,
      limit: 25,
      page: 1,
      reRenderPagination: 0,
      count: true,
      filters: {},
      getTotals: true,
      totals: {
        payed: 0,
        partial: 0,
        pending: 0,
        unpaid: 0,
        refunded: 0,
        total: 0,
      },
      modalUpdateOrderCommercialNotes: {
        display: false,
        order: undefined,
      },
      modalUpdateOrderManagerNotes: {
        display: false,
        order: undefined,
      },
    };
  },

  computed: {
    pageCount() {
      return Math.ceil(this.ordersTotal / this.limit);
    },
  },

  methods: {
    async loadOrders() {
      try {
        this.loading = true;

        const { data } = await this.$api.get("/orders/list", {
          params: {
            ...this.filters,
            offset: this.offset,
            limit: this.limit,
            currentTotal: this.ordersTotal,
            count: this.count,
          },
        });

        this.orders = data.data;
        this.ordersTotal = data.total;

        if (this.getTotals) {
          await this.getPricesTotals();
        }

        this.count = false;
      } catch (e) {
        this.$errorToast("Impossible de charger les commandes");
      } finally {
        this.loading = false;
      }
    },

    applyFilters(filters) {
      this.getTotals =
        !moment(this.filters.begin).isSame(moment(filters.begin), "day") ||
        !moment(this.filters.end).isSame(moment(filters.end), "day") ||
        this.filters.commercial !== filters.commercial;
      this.filters.coachManager !== filters.coachManager;

      this.filters = {
        ...this.filters,
        ...filters,
      };
      this.count = true;

      this.changePage(1);

      this.reRenderPagination++;
    },

    changePage(page) {
      this.page = page;
      this.offset = this.limit * page - this.limit;

      this.loadOrders();
    },

    async getPricesTotals() {
      const { begin, end, commercial } = this.filters;

      const { data } = await this.$api.get("/orders/prices-totals", {
        params: {
          begin,
          end,
          commercial,
        },
      });

      this.totals = { ...this.totals, ...data };
      this.getTotals = false;
    },

    goToOrder(order) {
      const route = this.$router.resolve({
        name: "order-details",
        params: {
          id: order.id,
        },
      });

      window.open(route.href, "_blank");
    },

    displayOrderCommercialNotes(order) {
      this.modalUpdateOrderCommercialNotes.display = true;
      this.modalUpdateOrderCommercialNotes.order = order;
    },

    async updateOrderCommercialNotes() {
      const { id, commercialNotes } =
        this.modalUpdateOrderCommercialNotes.order;

      await this.$api.put(`/orders/${id}`, {
        id,
        commercialNotes,
      });

      this.modalUpdateOrderCommercialNotes.display = false;
    },

    displayOrderNotes(order) {
      this.modalUpdateOrderManagerNotes.display = true;
      this.modalUpdateOrderManagerNotes.order = order;
    },

    async updateOrderNotes() {
      const { id, label } = this.modalUpdateOrderManagerNotes.order;

      await this.$api.put(`/orders/${id}`, {
        id,
        label,
      });

      this.modalUpdateOrderManagerNotes.display = false;
    },

    notebookNoteAdded({ orderId, note }) {
      const order = this.orders.find((o) => o.id === orderId);

      if (order) {
        this.orders = this.orders.map((o) =>
          o.id === orderId ? { ...o, notebook: [note, ...o.notebook] } : o,
        );
      }
    },

    notebookNoteUpdated({ orderId, note }) {
      const order = this.orders.find((o) => o.id === orderId);

      if (order) {
        this.orders = this.orders.map((o) =>
          o.id === orderId
            ? {
                ...o,
                notebook: o.notebook.map((n) => (n.id === note.id ? note : n)),
              }
            : o,
        );
      }
    },

    notebookNoteDeleted({ orderId, noteId }) {
      const order = this.orders.find((o) => o.id === orderId);

      if (order) {
        this.orders = this.orders.map((o) =>
          o.id === orderId
            ? {
                ...o,
                notebook: o.notebook.filter((n) => n.id !== noteId),
              }
            : o,
        );
      }
    },
  },
};
</script>
